import { Button, Divider, Grid, Typography } from "@mui/material";
import { Client } from "../../../../Types/Client";
import { Talent } from "../../../../Types/Talent";
import { AccountDeletionModal } from "./AccountDeletionModal";
import { useState } from "react";
import { EditAccountModal } from "./EditAccountModal";
import { CombinedUser, useUser } from "../../../../Hooks/useUser";
import { ProfileType } from "../../../../Types/General";
import { useToast } from "../../../../Hooks/useToast";
import { useActivateClientMutation } from "../../../../Redux/api/clientApi";
import { useActivateTalentMutation } from "../../../../Redux/api/talentApi";
import { KaziButton } from "../../../../Shared Components/Kazi/KaziButton";
import { useMobileView } from "../../../../Hooks/useMobileView";

interface ViewAccountInfoProps {
    user: CombinedUser;
}
export const ViewAccountInfo = ({ user }:ViewAccountInfoProps) => {
    /* ******************** Hooks ******************** */
    const { isActive, type, locator } = useUser();
    const { showToast } = useToast();
    const { flexDirection } = useMobileView();
    const [activateClient, {isLoading: clientActivating}] = useActivateClientMutation();
    const [activateTalent, {isLoading: talentActivating}] = useActivateTalentMutation();
    /* ******************** Variables ******************** */
    const [editOpen, setEditOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const isActivating = clientActivating || talentActivating;
    /* ******************** Functions ******************** */
    const handleReactivate = () => {
        if (type === ProfileType.Client) {
            activateClient(locator!)
            .unwrap()
            .then(() => {
                showToast({
                    text: 'Account Reactivated'
                })
            })
            .catch((err) => {
                console.error("Error occured while activating client: ", err)
                showToast({
                    text: 'Unable to Reactivate the Account',
                    variant: 'error'
                })
            })
        }

        if (type === ProfileType.Talent) {
            activateTalent(locator!)
            .unwrap()
            .then(() => {
                showToast({
                    text: 'Account Reactivated'
                })
            })
            .catch((err) => {
                console.error("Error occured while activating talent: ", err)
                showToast({
                    text: 'Unable to Reactivate the Account',
                    variant: 'error'
                })
            })

        }
    }
    const handleDelete = () => {
        setDeleteOpen(true)
    }
    const handleEdit = () => {
        setEditOpen(true)
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <Grid display={"flex"} flexDirection={"column"}  marginTop={'28px'}>
                <Grid display={"flex"} flexDirection={"column"} > 
                    <Grid display={"flex"} flexDirection={flexDirection}  marginBottom={1}>
                        <Typography variant='body-medium' marginRight={1} flex={1} alignSelf={'center'}>{`${user?.first_name} ${user?.last_name}`}</Typography>
                        <Typography variant='body-medium'  marginRight={0} flex={1} alignSelf={'center'}>{user?.email}</Typography>
                        <Grid display={"flex"} flexDirection={flexDirection} gap={"40px"} justifyContent={'flex-end'}>
                            {
                                isActive?
                                <Button variant='text' onClick={handleDelete}>Deactivate account</Button> :
                                <KaziButton 
                                    variant="text"
                                    onClick={handleReactivate}
                                    text="Reactivate account"
                                    loading={{
                                        isLoading: isActivating,
                                        loadingText: 'Reactivating account...'
                                    }}
                                />
                            }
                            <Button variant='outlined' onClick={handleEdit}>Edit</Button>
                        </Grid>
                    </Grid>
                    <Divider />
                </Grid>
            </Grid>
            <AccountDeletionModal
                open={deleteOpen}
                setOpen={setDeleteOpen}      
            />
            <EditAccountModal 
                open={editOpen} 
                setOpen={setEditOpen} 
            />
        </>
    )
}